import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Default } from "../Default";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Half = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(Default, _extends({}, props, {
    className: cn('half', {
      'half--max': props.cardType === 'max'
    }),
    "data-t-id": "CardTypes-Half"
  }));
});